import { render, staticRenderFns } from "./FeatureLockedNotify.vue?vue&type=template&id=7b530b54&scoped=true"
import script from "./FeatureLockedNotify.vue?vue&type=script&lang=ts"
export * from "./FeatureLockedNotify.vue?vue&type=script&lang=ts"
import style0 from "./FeatureLockedNotify.vue?vue&type=style&index=0&id=7b530b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b530b54",
  null
  
)

export default component.exports